import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';

export const DetailsContainer = styled.div`
  position: relative;
  flex-grow: 1;
`;

export const LoadContainer = styled.div`
  width: 50px;
  height: 50px;
  margin-top: 25px;
  margin-left: calc(50% - 25px);
`;

export const IconClose = styled(CloseIcon)`
  position: absolute;
  right: 5px;
  top: 0px;
  cursor: pointer;
  font-size: 14px !important;
`;

export const Details = styled.div`
  position: relative;
  padding-top: 20px;
`;